import LogoAlderney from "app/components/Logos/LogoAlderney";
import LogoEighteenPlus from "app/components/Logos/LogoEighteenPlus";
import LogoGamcare from "app/components/Logos/LogoGamcare";
import React from "react";
import { FormattedMessage } from "react-intl";
import "./Terms.scss";

//
function Terms(
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<"div">, "div"> {
  return (
    <div className="terms">
      <div className="terms__logos">
        <span
          onClick={() => {
            window.open(
              "https://www.gamblingcontrol.org/licensees/egambling-licensees/",
              "_blank"
            );
          }}
        >
          <LogoAlderney className="terms__logos__alderney-logo" />
        </span>
        <span
          onClick={() => {
            window.open("https://www.gamcare.org.uk/", "_blank");
          }}
          className="gamcare-link"
        >
          <LogoGamcare className="terms__logos__gamcare-logo" />
        </span>
        <LogoEighteenPlus className="terms__logos__eighteen-plus-logo" />
      </div>
      <span className="terms__text">
        <FormattedMessage id="cashier-footer" />
      </span>
      <div className="terms__buttons">
        <button
          className="terms__button"
          onClick={e => {
            // @ts-ignore
            FreshworksWidget("open", "article", {
              id: 103000015424,
            });
          }}
        >
          <FormattedMessage id="termsandconditions" />
        </button>
        <button
          className="terms__button"
          onClick={e => {
            // @ts-ignore
            FreshworksWidget("open", "article", {
              id: 103000015429,
            });
          }}
        >
          <FormattedMessage id="home-responsiblegaming" />
        </button>
        <button
          className="terms__button"
          onClick={e => {
            // @ts-ignore
            FreshworksWidget("open", "ticketForm");
          }}
        >
          <FormattedMessage id="helpandlearning-contactandsupport-contactus" />
        </button>
      </div>
    </div>
  );
}

export default Terms;
